import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription, timer, switchMap, takeWhile, take } from 'rxjs';
import { PurchaseService, PurchaseStatus } from '../services/purchase.service';

@Component({
  selector: 'app-purchase-complete',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <section class="complete" [ngSwitch]="state">
      <ng-container *ngSwitchCase="'waiting'">
        <h1>Bekræfter betaling...</h1>
<!--        <p>(Tager typisk et par sekunder)</p>-->
      </ng-container>

      <ng-container *ngSwitchCase="'paid'">
        <h1>Betaling modtaget</h1>
        <p>Dit hi-res billede er klar. Link'et virker en gang, så download på den enhed hvor du vil gemme det.</p>
        <a class="download" [routerLink]="result?.downloadPath">Download</a>
        <p class="note" *ngIf="result?.sentTo">(Link'et er også sendt til {{ result?.sentTo }})</p>
      </ng-container>

      <ng-container *ngSwitchCase="'failed'">
        <h1>Betaling gik ikke igennem</h1>
        <p>Der er ikke trukket penge - gå evt. tilbage til billedet og prøv igen.</p>
        <a routerLink="/">Tilbage</a>
      </ng-container>

      <ng-container *ngSwitchCase="'slow'">
        <h1>Venter (stadig) på MobilePay</h1>
        <p>Hvis du har godkendt betalingen vil du modtage et download link på email inden for et par minutter.</p>
        <button type="button" (click)="poll()">Check igen</button>
      </ng-container>
    </section>
  `,
  styles: [`
    .complete { max-width: 28rem; margin: 3rem auto; padding: 0 1rem; }
    .download {
      display: inline-block; margin: 0.5rem 0 1rem; padding: 0.85rem 1.25rem;
      border-radius: 6px; background: #5a78ff; color: #fff; font-weight: 600; text-decoration: none;
    }
    .download:focus-visible, button:focus-visible { outline: 3px solid #5a78ff; outline-offset: 2px; }
    .note { font-size: 0.9rem; opacity: 0.75; }
  `],
})
export class PurchaseCompleteComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private purchases = inject(PurchaseService);
  private sub?: Subscription;

  state: 'waiting' | 'paid' | 'failed' | 'slow' = 'waiting';
  result?: PurchaseStatus;
  private reference = '';

  ngOnInit() {
    this.reference = this.route.snapshot.queryParamMap.get('ref') ?? '';
    if (!this.reference) {
      this.state = 'failed';
      return;
    }
    this.poll();
  }

  /** Polls every 2 s for up to ~40 s. */
  poll() {
    this.sub?.unsubscribe();
    this.state = 'waiting';
    let lastStatus: PurchaseStatus | undefined;

    this.sub = timer(0, 2000).pipe(
      take(20),
      switchMap(() => this.purchases.status(this.reference)),
      takeWhile((s) => s.status === 'CREATED', true),
    ).subscribe({
      next: (s) => {
        lastStatus = s;
        if (s.status === 'PAID') { this.result = s; this.state = 'paid'; }
        if (s.status === 'FAILED') { this.state = 'failed'; }
      },
      complete: () => {
        if (!lastStatus || lastStatus.status === 'CREATED') this.state = 'slow';
      },
      error: () => (this.state = 'slow'),
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
